import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';

@Component({
    selector: 'app-end-season',
    templateUrl: './end-season.component.html',
    styleUrls: ['./end-season.component.css'],
    standalone: false
})
export class EndSeasonComponent implements OnInit{

  seasonId:number = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public endSeasonDialog: MatDialogRef<EndSeasonComponent>,
      public nav: NavBarComponent,
      private seasonManagerService: SeasonManagerService
   
  ) {}
  ngOnInit(): void {
      this.seasonId = this.data.seasonId;
  }
  
  close(): void {
    this.endSeasonDialog.close({"option": "cancel"});
  }

  endSeason(): void {
      this.nav.toggleLoading(true);
      this.seasonManagerService.updateEndSeasonById(this.seasonId).pipe(
          catchError(error => {
              console.error();
              this.nav.toggleLoading(false);
              return throwError(()=> error);
          })
      ).subscribe((response) => {
          this.endSeasonDialog.close({"option": "end"});
      })
  }
}
